import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const InviteDateTime = ({ eventDate, eventTime, message, onDateChange, onTimeChange, onMessageChange, onContinue }) => {
  const today = new Date().toISOString().split('T')[0];

  return (
    <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} className="w-full max-w-sm p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-2 text-center">Pick a Date & Time</h2>
      <p className="text-gray-500 text-sm mb-6 text-center">When works best for you?</p>
      <div className="space-y-4 mb-6">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">
            <SafeIcon name="Calendar" className="inline mr-1 text-pink-500" /> Date
          </label>
          <input type="date" min={today} value={eventDate} onChange={(e) => onDateChange(e.target.value)}
            className="w-full p-4 rounded-xl border border-gray-200 focus:border-pink-500 focus:ring-2 focus:ring-pink-100 outline-none" />
        </div>
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">
            <SafeIcon name="Clock" className="inline mr-1 text-pink-500" /> Time
          </label>
          <input type="time" value={eventTime} onChange={(e) => onTimeChange(e.target.value)}
            className="w-full p-4 rounded-xl border border-gray-200 focus:border-pink-500 focus:ring-2 focus:ring-pink-100 outline-none" />
        </div>
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">Add a note (optional)</label>
          <textarea value={message} onChange={(e) => onMessageChange(e.target.value)} rows="2"
            placeholder="Any preferences or notes..."
            className="w-full p-4 rounded-xl border border-gray-200 focus:border-pink-500 focus:ring-2 focus:ring-pink-100 outline-none resize-none" />
        </div>
      </div>
      <button onClick={onContinue} disabled={!eventDate || !eventTime}
        className="w-full bg-gradient-to-r from-pink-500 to-rose-500 text-white font-bold py-4 rounded-xl shadow-lg shadow-pink-200 disabled:opacity-50">
        Continue →
      </button>
    </motion.div>
  );
};

export default InviteDateTime;